/* eslint-disable no-process-env */

module.exports = {
  version: process.env.VERSION,
  contentCreatorAPI: {
    url: '/api/{version}/',
    endpoints: {
      campaigns: 'campaigns',
      campaignMedia: 'campaigns/{campaignId}/media',
      login: 'login',
      media: 'media',
      tos: 'tos/users/me',
      uploadMedia: 'media/upload',
      userMedia: 'users/me/media',
    },
  },
  pagination: {
    campaign: {
      loadingTemplates: 9,
      pageSize: 18,
    },
    community: {
      loadingTemplates: 9,
      pageSize: 18,
    },
    home: {
      loadingTemplates: 5,
      pageSize: 10,
    },
    profile: {
      loadingTemplates: 9,
      pageSize: 18,
    },
  },
  noPreviewImage: {
    url: '/statics/img/image-icon.png',
  },
};



// WEBPACK FOOTER //
// ./config/frontend.config.js